import type { PlainDate } from "@sa-nu/shared-utils/date";

/**
 * 選択範囲(firstNight〜lastNight)の中央日を返す。
 * 泊数が偶数で中央がちょうど取れない場合は、`computeCenteredRangeStart` の丸め方針に
 * 合わせて firstNight 側に切り捨てる。
 */
export function computeSelectionCenterNight({
  firstNight,
  lastNight,
}: {
  firstNight: PlainDate;
  lastNight: PlainDate;
}): PlainDate {
  const nightsSpan = firstNight.until(lastNight, { largestUnit: "day" }).days;
  return firstNight.add({ days: Math.floor(nightsSpan / 2) });
}
